export default {
  default: {
    container: "inline-flex items-center cursor-pointer text-text",
    checkbox:
      "w-6 h-6 border border-bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-paper",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-4 w-4 text-text",
    label: "text-sm font-medium",
    label_left: "mr-2",
    label_right: "ml-2",
    placeholder: "w-4 h-4 bg-transparent",
  },

  //"admin" analogue of "default" variant
  admin: {
    container: "inline-flex items-center cursor-pointer text-admin_text",
    checkbox:
      "w-6 h-6 border border-admin_bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-admin_paper",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-4 w-4 text-admin_text",
    label: "text-sm font-medium",
    label_left: "mr-2",
    label_right: "ml-2",
    placeholder: "w-4 h-4 bg-transparent",
  },

  compact: {
    container: "inline-flex items-center cursor-pointer text-text",
    checkbox:
      "w-4 h-4 border border-bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-primary",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-3 w-3 text-text_inv",
    label: "text-xs font-medium",
    label_left: "mr-1",
    label_right: "ml-1",
    placeholder: "w-3 h-3 bg-transparent",
  },

  admin_compact: {
    container: "inline-flex items-center cursor-pointer text-admin_text",
    checkbox:
      "w-5 h-5 border border-admin_bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-admin_primary border-admin_primary",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-3.5 w-3.5 text-admin_text_inv",
    label: "text-xs font-medium",
    label_left: "mr-1",
    label_right: "ml-1",
    placeholder: "w-3.5 h-3.5 bg-transparent",
  },
  
  large: {
    container: "inline-flex items-center cursor-pointer text-text",
    checkbox:
      "w-8 h-8 border border-bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-primary",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-6 w-6 text-text_inv",
    label: "text-base font-medium",
    label_left: "mr-3",
    label_right: "ml-3",
    placeholder: "w-6 h-6 bg-transparent",
  },

  admin_large: {
    container: "inline-flex items-center cursor-pointer text-admin_text",
    checkbox:
      "w-8 h-8 border border-admin_bordered rounded-full flex items-center justify-center",
    checkbox_checked: "bg-admin_primary",
    checkbox_unchecked: "bg-transparent",
    checkmark: "h-6 w-6 text-text_inv",
    label: "text-base font-medium",
    label_left: "mr-3",
    label_right: "ml-3",
    placeholder: "w-6 h-6 bg-transparent",
  },
}
